<template>
  <div>
    <div
      class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="d-flex">
        <div class="col-sm-10">
          <h1
            class="h2 text-muted"
            style="overflow: hidden; text-overflow: ellipsis; padding-right: 5%;"
          >
            MAPPING ENGINE / EDIT LOOKUP TABLE / {{ headTableName }}
          </h1>
        </div>

        <div class="col-sm-2" style="text-align: right;">
          <button
            type="button"
            class="btn btn-danger"
            data-bs-toggle="modal"
            data-bs-target="#removeModal"
          >
            Remove
          </button>
          <div class="divider" />
          <button
            class="btn btn-primary"
            type="submit"
            form="form_id"
            id="savebut"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <!-- Remove Table Modal -->
    <div
      class="modal fade"
      id="removeModal"
      tabindex="-1"
      aria-labelledby="removeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Lookup Table
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDelete" class="col-sm-8 col-form-label"
                >Are you sure you want to remove this lookup table? (Type yes to
                confirm)</label
              >
              <div class="col-sm-4">
                <input
                  class="form-control"
                  v-model="confirmDelete"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="deleteTable"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="updateTableError" class="alert alert-danger" role="alert">
      Error: {{ updateTableReason }}
    </div>
    <div class="row">
      <div class="col-sm-7">
        <form
          ref="form"
          id="form_id"
          class="row g-3 needs-validation"
          novalidate
          @submit.prevent="updateLookup"
        >
          <div>
            <label class="form-label">Lookup Table Name</label>
            <input
              type="text"
              class="form-control"
              v-model="tableName"
              required
            />
            <div class="invalid-feedback">
              Lookup Table Name is required!
            </div>
          </div>
          <div>
            <label class="form-label">Insurer</label>
            <select class="form-select" v-model="insurerId" required>
              <option
                v-for="insurer in insurers"
                v-bind:value="insurer.insurer_id"
                :key="insurer.insurer_id"
              >
                {{ insurer.insurer_name }}
              </option>
            </select>
            <div class="invalid-feedback">
              Insurer is required!
            </div>
          </div>
        </form>
      </div>
      <div class="col-sm-5">
        <label class="form-label">
          Matching options
        </label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="matchCaseInsensitive"
          />
          <label class="form-check-label">
            Case Insensitive matching
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="matchStripSpaces"
          />
          <label class="form-check-label">
            Strip Spaces when matching
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="matchPartial"
          />
          <label class="form-check-label">
            Match any part of the lookup value
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input cb"
            type="checkbox"
            value="first"
            id="first"
            @change="cbChange('first')"
          />
          <label class="form-check-label">
            <div class="d-flex">
              Match first &nbsp;
              <input
                type="text"
                class="form-control form-control-sm"
                style="width: 10%; height: 1.5rem; padding: 0rem 0rem; min-height: 0;"
                v-model="matchFirstCount"
              />
              &nbsp; characters only
            </div>
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input cb"
            type="checkbox"
            value="last"
            id="last"
            @change="cbChange('last')"
          />
          <label class="form-check-label">
            <div class="d-flex">
              Match last &nbsp;
              <input
                type="text"
                class="form-control form-control-sm"
                style="width: 10%; height: 1.5rem; padding: 0rem 0rem; min-height: 0;"
                v-model="matchLastCount"
              />
              &nbsp; characters only
            </div>
          </label>
        </div>
      </div>
    </div>
    <form class="row g-3 mt-3 px-3">
      <div class="col-sm-1" style="width: 4.16666667%">
        <input
          class="form-check-input"
          type="checkbox"
          @change="selectAll"
          v-model="allSelected"
        />
      </div>
      <div class="col-sm-7">
        <h6>Lookup Value</h6>
      </div>
      <div class="col-sm-4">
        <h6>Result</h6>
      </div>
    </form>
    <div class="accordion accordion-flush" id="accordionFlushExample">
      <div
        class="accordion-item"
        v-for="(row, index) in tableData"
        :key="index"
      >
        <!-- <h2 class="accordion-header"> -->
        <div class="d-flex" style="padding-left: 1rem">
          <div class="col-sm-1 align-self-center" style="width: 4.16666667%">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="selected"
              v-bind:value="row.insurer_lookup_table_data_id"
              :key="row.insurer_lookup_table_data_id"
              @click="select"
            />
          </div>
          <button
            class="accordion-button collapsed col-md-11"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + row.insurer_lookup_table_data_id"
            aria-expanded="false"
            aria-controls="flush-collapseOne"
            style="padding: 1rem 0rem; width: 90%"
          >
            <div
              class="col-sm-7"
              style="width: 64.8%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
            >
              {{ row.lookup_value }}
            </div>
            <div
              class="col-sm-4"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
            >
              {{ row.result ? "Decline" : "Accept" }}
            </div>
          </button>
        </div>
        <!-- </h2> -->
        <div
          :id="'collapse' + row.insurer_lookup_table_data_id"
          class="accordion-collapse collapse mt-3 px-3"
          aria-labelledby="flush-headingOne"
          style="width: 95%;"
          data-bs-parent="#accordionFlushExample"
        >
          <div
            v-if="updateDataError"
            class="alert alert-danger"
            role="alert"
            style="margin-left: 4%;"
          >
            Error: {{ updateDataReason }}
          </div>
          <form class="row g-3">
            <div class="col-sm-1" style="width: 4.16666667%"></div>
            <div class="col-sm-7">
              <input
                type="text"
                class="form-control"
                v-model="row.lookup_value"
              />
            </div>
            <div class="col-sm-2" style="margin-left: auto;">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="row.result"
                  value="0"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Accept
                </label>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="row.result"
                  value="1"
                />
                <label class="form-check-label" for="flexRadioDefault2">
                  Decline
                </label>
              </div>
            </div>
          </form>
          <div class="form-group mt-3 mb-3" style="text-align:right;">
            <button
              class="btn btn-secondary"
              type="button"
              @click="cancelUpdate(row.insurer_lookup_table_data_id)"
            >
              Cancel
            </button>
            <div class="divider" />
            <button
              class="btn btn-primary"
              type="button"
              @click="updateData(row)"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card collapse collapsing mt-3" id="addRow" style="width: 93%;">
      <div
        v-if="addError"
        class="alert alert-danger mt-3"
        role="alert"
        style="margin-left: 4%; margin-right: 2%;"
      >
        Error: {{ addReason }}
      </div>
      <form
        ref="form"
        id="addForm"
        class="d-flex mt-3 needs-validation"
        novalidate
        @submit.prevent="addData"
        style="align-items: center;"
      >
        <div class="col-sm-1" style="width: 4.16666667%"></div>
        <div class="col-sm-7">
          <input type="text" class="form-control" v-model="newValue" required />
          <div class="invalid-feedback">
            Lookup name is required!
          </div>
        </div>
        <div class="form-group d-flex">
          <div class="col-sm-2" style="margin-left: auto; margin-right: auto;">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="accept"
                value="0"
                v-model="newResult"
                required
              />
              <label class="form-check-label" for="flexRadioDefault1">
                Accept
              </label>
              <div class="invalid-feedback" style="width: max-content;">
                Result is required!
              </div>
            </div>
          </div>
          <div class="col-sm-2" style="margin-left: auto;">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="decline"
                value="1"
                v-model="newResult"
                required
              />
              <label class="form-check-label" for="flexRadioDefault2">
                Decline
              </label>
            </div>
          </div>
        </div>
      </form>
      <div
        class="form-group mt-3 mb-3"
        style="text-align:right;margin-right: 1rem;"
      >
        <button class="btn btn-secondary" type="button" @click="clear">
          Cancel
        </button>
        <div class="divider" />
        <button class="btn btn-primary" type="submit" form="addForm">
          Save Changes
        </button>
      </div>
    </div>
    <div
      class="mt-4 mb-5 px-3"
      style="display: flex;
  justify-content: space-between; width: 95%;"
    >
      <button
        type="button"
        class="btn btn-secondary"
        data-bs-toggle="modal"
        data-bs-target="#removeRowsModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-trash"
          viewBox="0 0 16 16"
        >
          <path
            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
          />
          <path
            fill-rule="evenodd"
            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
          />
        </svg>

        Remove Selected Rows
      </button>
      <div style="text-align:right;">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-toggle="collapse"
          data-bs-target="#addRow"
        >
          Add Row
        </button>
        <div class="divider" />
        <button type="button" class="btn btn-secondary" @click="exportCSV">
          Export CSV
        </button>
        <div class="divider" />
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-toggle="modal"
          data-bs-target="#importModal"
        >
          Import CSV
        </button>
      </div>
    </div>
    <!-- Import Modal -->
    <div
      class="modal fade"
      id="importModal"
      tabindex="-1"
      aria-labelledby="importModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Upload a CSV Lookup Table
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="clearFile"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3 mt-3">
              <label for="inputGroupFile02" class="col-sm-3 col-form-label"
                >Select a file</label
              >
              <div class="col-sm-9">
                <input
                  ref="file"
                  type="file"
                  class="form-control"
                  id="inputGroupFile02"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="clearFile"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="importCSV"
              data-bs-toggle="modal"
              data-bs-target="#uploadDetailsModal"
            >
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Import Details Modal -->
    <div
      class="modal fade"
      id="uploadDetailsModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="uploadDetailsModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Upload Details
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="clearError"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-4 mt-3">
              <div class="row" v-if="fileupload">
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="green"
                    class="bi bi-check-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">Your Upload has been completed.</div>
              </div>
              <div class="row" v-else>
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="red"
                    class="bi bi-x-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  Your file could not be uploaded. Please check.
                </div>
              </div>
              <div class="row" v-if="format">
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="green"
                    class="bi bi-check-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  The format of your file appears to be right.
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="red"
                    class="bi bi-x-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  The format of your file does not appear to be right. Please
                  check.
                </div>
              </div>
              <div class="row" v-if="entries">
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="green"
                    class="bi bi-check-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  {{ numentries }} Entries have been processed.
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="red"
                    class="bi bi-x-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  No entries have been processed. Please check.
                </div>
              </div>
            </div>
            <div
              class="alert alert-danger align-items-center mt-3"
              role="alert"
              v-if="error"
            >
              <div class="d-flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                  viewBox="0 0 16 16"
                  role="img"
                  aria-label="Warning:"
                >
                  <path
                    d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                  />
                </svg>
                <div>
                  Warning: Rows {{ failedRowList }} have not been processed.
                  Please check.
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="clearError"
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Remove Rows Modal -->
    <div
      class="modal fade"
      id="removeRowsModal"
      tabindex="-1"
      aria-labelledby="removeRowsModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Selected Rows
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDelete" class="col-sm-8 col-form-label"
                >Are you sure you want to remove selected rows? (Type yes to
                confirm)</label
              >
              <div class="col-sm-4">
                <input
                  class="form-control"
                  v-model="confirmDelete"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="deleteRows"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";
import config from "../../config";
export default {
  data() {
    return {
      insurers: [],
      tableName: "",
      headTableName: "",
      insurerId: "",
      matchCaseInsensitive: false,
      matchStripSpaces: false,
      matchPartial: false,
      matchFirstCount: null,
      matchLastCount: null,
      tableData: [],
      selected: [],
      allSelected: false,
      newValue: "",
      newResult: null,
      fileupload: false,
      format: false,
      entries: false,
      error: false,
      failedRowList: [],
      confirmDelete: "",
      addError: false,
      addReason: "",
      updateTableError: false,
      updateTableReason: "",
      updateDataError: false,
      updateDataReason: "",
    };
  },
  methods: {
    cbChange(obj) {
      var instate = document.getElementById(obj).checked;
      var cbs = document.getElementsByClassName("cb");
      for (var i = 0; i < cbs.length; i++) {
        cbs[i].checked = false;
      }
      if (instate) document.getElementById(obj).checked = true;
    },
    async addData() {
      const form = document.getElementById("addForm");
      if (form.checkValidity()) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              insurer_lookup_table_id: this.$route.params.id,
              lookup_value: this.newValue,
              result: parseInt(this.newResult),
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/add_lookup_data",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) {
          this.getDeets();
          this.clear();
        } else {
          this.addError = true;
          this.addReason = data["reason"];
        }
      }
    },
    clear() {
      $("#addRow").collapse("hide");
      this.newValue = "";
      this.newResult = null;
      this.addError = false;
      this.addReason = "";
      $("#addForm").removeClass("was-validated");
    },
    async updateData(row) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_lookup_table_data_id: row.insurer_lookup_table_data_id,
            lookup_value: row.lookup_value,
            result: parseInt(row.result),
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/update_lookup_data",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Added"]) {
        // this.getDeets();
        // $("#collapse" + row.insurer_lookup_table_data_id).collapse("hide");
        this.cancelUpdate(row.insurer_lookup_table_data_id);
      } else {
        this.updateDataError = true;
        this.updateDataReason = data["reason"];
      }
    },
    cancelUpdate(id) {
      this.getDeets();
      $("#collapse" + id).collapse("hide");
      this.updateDataError = false;
      this.updateDataReason = "";
    },
    async deleteRows() {
      if (this.confirmDelete.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              insurer_lookup_table_data_ids: this.selected,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_lookup_data",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Removed"]) {
          this.getDeets();
          this.confirmDelete = "";
        }
      } else {
        this.confirmDelete = "";
      }
    },
    async importCSV() {
      const obj = {
        insurer_lookup_table_id: this.$route.params.id,
      };
      const json = JSON.stringify(obj);
      const blob = new Blob([json], {
        type: "application/json",
      });
      const data = new FormData();
      data.append("data", blob);
      data.append("lookup_data", this.$refs.file.files.item(0));
      $("#inputGroupFile02").val("");
      const requestOptions = {
        method: "POST",
        credentials: "include",
        body: data,
      };
      const response = await fetch(
        config.baseURL + "/save_lookup_data_csv",
        requestOptions
      );
      const res = await response.json();
      console.log(res);
      this.getDeets();
      if (res) this.fileupload = true;
      if (res["Format"]) this.format = true;
      if (res["Number_of_rows_added"]) {
        this.entries = true;
        this.numentries = res["Number_of_rows_added"];
      }
      if (res.failed_row_list.length !== 0) {
        this.error = true;
        this.failedRowList = res.failed_row_list;
      }
    },
    clearError() {
      this.fileupload = false;
      this.format = false;
      this.entries = false;
      this.numentries = 0;
      this.failedRowList = [];
    },
    async exportCSV() {
      let csv = '"insurer_lookup_table_data_id","lookup_value","decline"\n';
      this.tableData.forEach((row) => {
        csv +=
          '"' +
          row.insurer_lookup_table_data_id +
          '","' +
          row.lookup_value +
          '","' +
          row.result;
        csv += '"\n';
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Lookup_table_data.csv";
      anchor.click();
    },
    clearFile() {
      $("#inputGroupFile02").val("");
    },
    selectAll() {
      this.selected = [];
      if (this.allSelected) {
        for (var row in this.tableData) {
          this.selected.push(this.tableData[row].insurer_lookup_table_data_id);
        }
      }
    },
    select() {
      this.allSelected = false;
    },

    async updateLookup() {
      const form = document.getElementById("form_id");
      if (form.checkValidity()) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              insurer_lookup_table_id: this.$route.params.id,
              table_name: this.tableName,
              insurer_id: this.insurerId,
              match_case_insensitive: this.matchCaseInsensitive,
              match_strip_spaces: this.matchStripSpaces,
              match_partial: this.matchPartial,
              match_first_chars: document.getElementById("first").checked,
              match_last_chars: document.getElementById("last").checked,
              match_char_count: document.getElementById("first").checked
                ? this.matchFirstCount
                : document.getElementById("last").checked
                ? this.matchLastCount
                : null,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/update_lookup_table",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) this.$router.push("/lookup");
        else {
          this.updateTableError = true;
          this.updateTableReason = data["reason"];
        }
      }
    },
    async deleteTable() {
      if (this.confirmDelete.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              insurer_lookup_table_id: this.$route.params.id,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_lookup_table",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Completed"]) {
          this.$router.push("/lookup");
        }
      } else {
        this.confirmDelete = "";
      }
    },
    async getDeets() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_lookup_table_id: this.$route.params.id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_single_lookup_table",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (!data["Accepted"]) this.$router.push("/error");
      this.headTableName = data["lookup_table_details"]["table_name"];
      this.tableName = data["lookup_table_details"]["table_name"];
      this.insurerId = data["lookup_table_details"]["insurer_id"];
      this.matchCaseInsensitive =
        data["lookup_table_details"]["match_case_insensitive"];
      this.matchStripSpaces =
        data["lookup_table_details"]["match_strip_spaces"];
      this.matchPartial = data["lookup_table_details"]["match_partial"];
      if (data["lookup_table_details"]["match_first_chars"]) {
        document.getElementById("first").checked = true;
        this.matchFirstCount = data["lookup_table_details"]["match_char_count"];
      } else if (data["lookup_table_details"]["match_last_chars"]) {
        document.getElementById("last").checked = true;
        this.matchLastCount = data["lookup_table_details"]["match_char_count"];
      }
      this.tableData = data["table_data"];
    },
    async getInsurers() {
      const ires = await fetch(config.baseURL + "/get_insurers", {
        credentials: "include",
      });
      const idata = await ires.json();
      this.insurers = idata;
    },
  },
  mounted() {
    this.getDeets();
    this.getInsurers();
    const form = document.getElementById("form_id");
    form.addEventListener(
      "submit",
      function(event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false
    );
    const form1 = document.getElementById("addForm");
    form1.addEventListener(
      "submit",
      function(event) {
        if (!form1.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form1.classList.add("was-validated");
      },
      false
    );
  },
};
</script>

<style scoped>
.divider {
  width: 10px;
  height: auto;
  display: inline-block;
}
</style>
